import { clickedAnalytics, IClickedAnalyticsPayload } from '@bridebook/web/lib/ui/analytics';
import { useDispatch } from '@bridebook/web/lib/utils';
import { useIsMotifActive } from '@bridebook/web/lib/wedding-website/motif/hooks/use-motif-flags';
import { useCallback } from 'react';

export type ShareWebsiteClickedLocation =
  | 'weddingWebsitesPage'
  | 'weddingWebsitesDesktop'
  | 'weddingWebsites_preview'
  | 'weddingWebsites_publish';

export type ShareWebsiteCta = 'Share' | 'Copy link' | 'Message guests';

export interface IShareWebsiteClickPayload
  extends Pick<IClickedAnalyticsPayload, 'sectionsOrderDict' | 'defaultOrderingFlag'> {
  clickedLocation: ShareWebsiteClickedLocation;
  cta: ShareWebsiteCta;
  category?: 'weddingWebsites';
}

/**
 * Dispatches the `Clicked` event for every wedding-website share entry point. Owns the two parts that
 * must be identical everywhere: the `shareButton` section and the `themeGeneratedAi` flag, which lets BI
 * split share funnels by AI-generated vs classic themes.
 *
 * Each caller still passes its own location, cta and section-order props, so payloads stay per-site.
 */
export const useShareWeddingWebsiteClick = () => {
  const dispatch = useDispatch();
  const themeGeneratedAi = useIsMotifActive();

  const trackShareWeddingWebsiteClick = useCallback(
    (payload: IShareWebsiteClickPayload) =>
      dispatch(clickedAnalytics({ ...payload, clickedSection: 'shareButton', themeGeneratedAi })),
    [dispatch, themeGeneratedAi],
  );

  return { trackShareWeddingWebsiteClick };
};
